import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, Gavel } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { fetchBanAuditLog, type AuditRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A8.02 — Ban / unban tarixi: kim qachon qaysi foydalanuvchini bloklab/ochib,
 * qaysi sabab bilan. Yangi endpoint YO'Q — mavjud `/admin/audit` ni
 * `ban_user`/`unban_user` amallariga filtrlaydi. Sabab `detail` ustunida.
 */
export function BanAuditLog() {
  const t = useT()

  const columns = useMemo<AdminColumn<AuditRow>[]>(
    () => [
      { key: 'created_at', header: t.col.time, type: 'date', width: 150 },
      { key: 'admin', header: t.col.staff, type: 'text', width: 160 },
      {
        key: 'action',
        header: t.col.action,
        type: 'enum',
        width: 150,
        options: [
          { value: 'ban_user', label: t.users.ban, status: 'banned' },
          { value: 'unban_user', label: t.users.unban, status: 'active' },
        ],
      },
      { key: 'target', header: t.col.target, type: 'id', width: 140 },
      { key: 'detail', header: t.col.detail, type: 'longtext', minWidth: 200 },
      { key: 'ip', header: t.col.ip, type: 'id', width: 150, piiLevel: 'L3' },
    ],
    [t],
  )

  const fetcher = useCallback(fetchBanAuditLog, [])

  return (
    <>
      <PageHeader
        title={t.users.banLog}
        screenId="A8.02"
        actions={
          <Link
            to="/users"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {t.nav.users}
          </Link>
        }
      />
      <DataTable<AuditRow>
        screenId="A8.02"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id ?? `${r.created_at}:${r.target ?? ''}`)}
        exportable
        emptyState={{ icon: <Gavel size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
